import { Component, OnInit } from '@angular/core';
import { WinService } from 'src/app/services/win.service';
// import { DomSanitizer, Title } from '@angular/platform-browser';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { CmsService } from 'src/app/services/api/cms.service';
import { ActivatedRoute } from '@angular/router';

@Component({
	selector: 'app-cmspages',
	templateUrl: './cmspages.component.html',
	styleUrls: ['./cmspages.component.scss']
})
export class CmspagesComponent implements OnInit {
	content: any;
	page: string;
	pageId: any = null;

	faqContent: any;
	faqTagalogContent: any;

	constructor(
		public winService: WinService,
		public cms: CmsService,
		public sanitizer: DomSanitizer,
		private activeRoute: ActivatedRoute,
		private title: Title
	) { }

	ngOnInit() {

		this.activeRoute.paramMap.subscribe(urlParam => {
		this.page = urlParam.get('page');
		window.scrollTo(0, 0);

		if (this.page === 'terms&conditions') {
			this.pageId = 5;
			this.title.setTitle('Terms and Conditions');
		}
		else if (this.page === 'privacypolicy') {
			this.pageId = 4;
			this.title.setTitle('Privacy Policy');
		}
		else if (this.page === 'entrepouch') {
			this.pageId = 6;
			this.title.setTitle('Entrepouch');
		}
		else if (this.page === 'about-us') {
			this.pageId = 14;
			this.title.setTitle('About Us');
		}
		else if (this.page === 'faq') {
			this.pageId = 7;
			this.title.setTitle('FAQs');
		}
		/* else if(this.page === 'faq-tagalog'){
			this.pageId = 9;
			this.title.setTitle('FAQs');
		} */
		this.getData(this.pageId);
			/* this.cms.getPage(pageId, false, false).then(res => {
				this.content = res.content;
			}); */
		});

	}

	/**
	 * if the page is faq we should init its click listener
	 */
	initFaq() {
		let element: any = null;
		if (this.page === 'faq') {
			element = document.getElementById("accordion-items");
		} else if (this.page === 'faq-tagalog') {
			element = document.getElementById("accordion-items-tagalog");
		}
		if (!element) {
			setTimeout(f => {
				this.initFaq();
			}, 1000);
		}
		else {
			let elItems = element.children;
			let a = this;
			for (var i = 0; i < elItems.length; i++) {
				elItems[i].onclick = function () {
					a.faqItemOnClick(this);
				}
			}
		}
	}

	faqItemOnClick(e) {
		let element: any = null;
		if (this.page === 'faq') {
			element = document.getElementById("accordion-items");
		} else if (this.page === 'faq-tagalog') {
			element = document.getElementById("accordion-items-tagalog");
		}
		if (element) {
			let elItems = element.children;
			for (var i = 0; i < elItems.length; i++) {
				elItems[i].classList.remove('active');
				elItems[i].classList.remove('selected');
			}
			e.classList.add('active');
			e.classList.add('selected');
		}
	}

	getData(pageId) {
		this.cms.getPage(pageId, false, false).then(res => {
			if (this.page === 'faq') {
				this.faqContent = res.content;
				this.initFaq();
			}
			else if (this.page === 'faq-tagalog') {
				this.faqTagalogContent = res.content;
				this.initFaq();
			} else {
				this.content = res.content;
			}
		});
	}

	changeLang(lang: string = 'en') {
		if (lang == 'en') {
			this.page = 'faq';
			this.pageId = 7;
			if (!this.faqContent) {
				this.getData(this.pageId);
			} else {
				this.initFaq();
			}
		}
		if (lang == 'ph') {
			this.page = 'faq-tagalog';
			this.pageId = 9;
			if (!this.faqTagalogContent) {
				this.getData(this.pageId);
			} else {
				this.initFaq();
			}
		}
	}
}
